<div class="lb-associated-contacts-widget">
	<lb-detail-widget iconName="untitled-ui/users/users-01">
		<div class="info-row-full">
			<span class="md-text-sm-semibold">{{ title() }}</span>
			<div class="list">
				@let userList = users();
				@if (!userList || userList.length === 0) {
					<span class="md-text-sm-regular">-</span>
				} @else {
					@for (user of userList; track user.userID) {
						<div class="contacts">
							<a [class.contacts--clickable]="!!user.route" [routerLink]="user.route ?? null">
								<lb-user-icon [userID]="user.userID" class="user-icon"></lb-user-icon>
							</a>
							<div>
								<div class="top-row">
									<span class="md-text-sm-medium" [class.user-link]="!!user.route">{{ user.firstName }} {{ user.lastName }}</span>
								</div>
								<span class="md-text-sm-regular">
									{{ user.personalEmail }}
									<lb-copy-to-clipboard
										[textToCopy]="user.personalEmail"
										[showConfirmation]="true"
										confirmationText="Copied Email"
									></lb-copy-to-clipboard>
								</span>
							</div>
						</div>
						@if (!$last) {
							<lb-divider></lb-divider>
						}
					}
				}
			</div>
		</div>
	</lb-detail-widget>
</div>
